import { useEffect, useRef, useState, useCallback } from 'react';
import { NotificationsApi } from '../api/notificationsApi';

const DEFAULT_POLL_MS = 15000;

export default function useNotifications() {
  const [items, setItems] = useState([]);
  const timer = useRef(null);

  const fetchUnread = useCallback(async () => {
    const { data } = await NotificationsApi.getNotifications({
      status: 'unread',
      page: 1,
      pageSize: 20,
    });
    setItems(data?.data || []);
  }, []);

  const markRead = useCallback(async (id) => {
    await NotificationsApi.markAsRead(id);
    setItems((prev) => prev.filter((n) => n.id !== id));
  }, []);

  const markAllRead = useCallback(async () => {
    await NotificationsApi.markAllAsRead();
    setItems([]);
  }, []);

  useEffect(() => {
    let mounted = true;

    const tick = async () => {
      try {
        if (mounted) await fetchUnread();
      } catch (_) {}
    };

    tick();
    timer.current = setInterval(tick, DEFAULT_POLL_MS);

    return () => {
      mounted = false;
      if (timer.current) clearInterval(timer.current);
    };
  }, [fetchUnread]);

  return { items, unread: items.length, markRead, markAllRead, refetch: fetchUnread, };
}